import { type PlanningPolicy } from "@/api/planningPolicy";

import { planningPolicyEntity } from "./entities";
import { EntityCombobox } from "./EntityCombobox";

interface Props {
  value: number | null;
  onChange: (id: number | null) => void;
  size?: "sm" | "default";
  className?: string;
  triggerClassName?: string;
  emptyLabel?: string;
  renderTriggerContent?: (selected: PlanningPolicy | null) => React.ReactNode;
  variant?: "outline" | "ghost";
  disabled?: boolean;
  ariaLabel?: string;
  hideChevron?: boolean;
}

export function PlanningPolicyCombobox(props: Props) {
  return (
    <EntityCombobox<PlanningPolicy>
      descriptor={planningPolicyEntity}
      allowClear
      {...props}
    />
  );
}
